import React from 'react';
import { CLINIC_SOCIAL_LINKS } from '../data/socialLinks';
import { useLocale } from '../context/LocaleContext';

export default function HeaderSocialLinks({ className, linkClassName }) {
  const { t } = useLocale();

  return (
    <nav className={className} aria-label={t('topbar.socialAria')}>
      {CLINIC_SOCIAL_LINKS.map((link) => (
        <a
          key={link.id}
          className={`${linkClassName} ${linkClassName}_${link.id}`}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t(link.labelKey)}
        >
          <i className={link.iconClass} aria-hidden="true" />
        </a>
      ))}
    </nav>
  );
}
